import * as React from 'react';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../Types';
import Label from '../Label';

export interface Props {
  resource: ExperienceResource;
}

const CompetencyList: React.FC<Props> = ({ resource }) => {
  switch (resource.payload.offeringType) {
    case 'epc':
    case 'aep':
    case 'group-coaching':
    case 'program-sequence': {
      return resource.payload.competencies.map((competency) => (
        <Label competency={competency} key={competency.payload.id} />
      ));
    }
    case 'coaching':
      return <></>;
  }
};

export default observer(CompetencyList);
